export const getFullName = (first?: string, last?: string) => {
  return [first, last].filter(Boolean).join(" ");
};
